import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box, Link, Container } from "theme-ui";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Box sx={{
      mt: 30,
      mx: "auto",
      pb: 120,
      width: [1, 1, 1 / 2]
    }} mdxType="Box">
      <h2 {...{
        "id": "this-content-is-exclusive-for-students"
      }}>{`This content is exclusive for students`}</h2>
      <p>{`Please login to view this page.`}</p>
      <p>{`You can still become a student!`}</p>
    </Box>
    <Container sx={{
      textAlign: 'center',
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5]
    }} mdxType="Container">
      <p>{`30 day moneyback guarantee.`}</p>
    </Container>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      